module.exports = __webpack_public_path__ + "img/4.c47791c7.png";